import { Fragment, useState, useRef } from "react";
import PropTyps from "prop-types";
import TeamInfo from "../../components/team-info";

const TeamCard = ({ data }) => {
    const [modalShow, setModalShow] = useState(false);
    const triggerRef = useRef(null);

    const onModalHandler = (data) => {
        setModalShow((prev) => !prev);
    };

    const onCardClick = (e) => {
        triggerRef.current = e.currentTarget;
        onModalHandler();
    };

    const onCardKeyDown = (e) => {
        // Custom role="button" must only activate on Enter/Space,
        // otherwise Tab/Escape/arrow keys incorrectly toggle the modal.
        if (e.key !== "Enter" && e.key !== " ") return;
        e.preventDefault(); // stop Space from scrolling the page
        triggerRef.current = e.currentTarget;
        onModalHandler();
    };

    return (
        <Fragment>
            <div
                className="team-card focus-visible-outline"
                // onClick={() => onModalHandler(data)}
                // onKeyDown={() => onModalHandler(data)}
                onClick={onCardClick}
                onKeyDown={onCardKeyDown}
                role="button"
                tabIndex="0"
                style={{ height: 385 }}
            >
                <div className="thumb">
                    <img
                        src={process.env.PUBLIC_URL + data.thumb}
                        alt={data.name}
                        className="img-bottom-border"
                    />
                </div>
                <div className="content">
                    <h2 className="title">{data.name}</h2>
                    <span>{data.designation}</span>
                </div>
            </div>

            <TeamInfo
                show={modalShow}
                data={data}
                onClose={onModalHandler}
                triggerRef={triggerRef}
            />
        </Fragment>
    );
};

TeamCard.propTypes = {
    data: PropTyps.object,
};

export default TeamCard;
